import React from "react";
import { Box, Typography } from "@material-ui/core";

const PayrollCostPerSqftTitle = () => {
    const label = "Payroll cost per square foot";

    return (
        <Box display="flex" data-cy="property-cost-per-square-foot-title" pb={1}>
            <Typography variant="h6">{label}</Typography>
        </Box>

    );
};

export default PayrollCostPerSqftTitle; 
